const startDate = new Date().setDate(1);
const filterConfig = {
  type: "object",
  properties: {
    search: {
      type: "string",
    },
    emitter_id: {
      type: "number",
    },
    // Selector con las opciones Liquidado, Pendiente y todas con valor por defecto en liquidado
    status: {
      type: "string",
      oneOf: [
        {
          const: "liquidated",
          title: "Liquidado",
        },
        {
          const: "pending",
          title: "Pendiente",
        },
        {
          const: "all",
          title: "Todas",
        },
      ],
      default: "pending",
    },
  },
};
const getFiltersConfig: any = (type: string) => {
  return filterConfig;
};
export default getFiltersConfig;
